The value of `CandidateProcessHistoryItem.id` for the requested object.
